// Brücke zwischen Turbo Drive und Seiten, die selbst History-Einträge schreiben
// (die React-App der Task-Erfassung, browser-location.ts). Muss vor Turbo
// geladen werden (erster Import in index.js): Turbo registriert seinen
// popstate-Listener beim Laden, und Listener am window laufen in der
// Reihenfolge der Registrierung. Nur so kann die Seite einen Sprung innerhalb
// der Seite übernehmen, bevor Turbo die Seite neu lädt.
//
// Protokoll (CustomEvents am window, beide abbrechbar):
//   tyme:pushstate  detail { url }  – die Brücke legt den Eintrag über Turbos
//                                     History an (Index, Kennung, Ort bleiben
//                                     synchron) und ruft preventDefault().
//   tyme:popstate   detail { state } – ruft die Seite preventDefault(), hält
//                                     die Brücke das popstate von Turbo fern
//                                     und gleicht Turbos History ab.
//
// Turbo wird erst zur Laufzeit über window.Turbo angesprochen, damit dieses
// Modul vor Turbo ausgewertet wird.

function turboHistory() {
  return window.Turbo?.session?.history
}

export function onPushState(event) {
  const history = turboHistory()
  if (!history) return

  history.push(new URL(event.detail.url, window.location.href))
  event.preventDefault()
}

export function onPopState(event) {
  const claim = new CustomEvent("tyme:popstate", { cancelable: true, detail: { state: event.state } })
  window.dispatchEvent(claim)
  if (!claim.defaultPrevented) return

  event.stopImmediatePropagation()

  // Wie Turbos eigener popstate-Handler, nur ohne Besuch
  const history = turboHistory()
  if (!history) return
  history.location = new URL(window.location.href)
  const turbo = event.state?.turbo
  if (turbo) {
    history.restorationIdentifier = turbo.restorationIdentifier
    history.currentIndex = turbo.restorationIndex
  }
}

export function installTurboHistoryBridge() {
  window.addEventListener("tyme:pushstate", onPushState)
  window.addEventListener("popstate", onPopState)
}

installTurboHistoryBridge()
